"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _max3 = _interopRequireDefault(require("lodash/max"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _angieslistAppPlatform = require("angieslist-app-platform");

require("./OfficeFooter.scss");

require("./FooterSiteMap.scss");

/* eslint-disable react/forbid-prop-types */

/* eslint-disable react/require-default-props */
var FooterSiteMap = function FooterSiteMap(_ref) {
  var sitemap = _ref.sitemap,
      align = _ref.align,
      minColumnCount = _ref.minColumnCount;
  var sectionCount = Object.keys(sitemap).length;

  if (12 % sectionCount !== 0) {
    throw new Error("The number of sections cannot be ".concat(sectionCount, ". It must be a factor of 12."));
  }

  var adjustedSectionCount = (0, _max3["default"])([sectionCount, minColumnCount]);
  var colSpan = 12;
  var offset = align === 'right' ? (adjustedSectionCount - sectionCount) * colSpan : 0;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "footer-site-map-row"
  }, Object.keys(sitemap).map(function (category, idx) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
      xs: colSpan,
      xsOffset: offset,
      key: "".concat(idx + 1),
      className: "footer-base-sitemap-col"
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: sectionCount === 1 ? 'single-section-ul' : ''
    }, /*#__PURE__*/_react["default"].createElement("li", {
      className: "footer-sitemap-li"
    }, category), Object.keys(sitemap[category]).map(function (title, i) {
      var value = sitemap[category][title];
      var id = value.id !== undefined ? value.id : title;
      return /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
        key: "".concat(i + 1)
      }, /*#__PURE__*/_react["default"].createElement("li", {
        key: "".concat(i + 1),
        id: "footer--sitemap-listItem-".concat(id),
        className: "footer-sitemap-li-item"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
        key: "footer--sitemap-item-".concat(i + 1)
      }, /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, value, {
        id: "footer--sitemap-item-".concat(id)
      }), title))));
    })));
  }));
};

var _default = FooterSiteMap;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/footer/FooterSiteMap.js
// module id = 3516
// module chunks = 25